<template>
    <div class="career-job">
        <div class="row">
            <ModelISOYM
                v-model="jobValue.dateStart"
                label="Дата начала"
                class="model"
                @change="updateJobValue"
            />

            <ModelCheckbox
                v-if="isMobile"
                v-model="jobValue.isUntilNow"
                label="По настоящее время"
                @change="updateJobValue"
            />

            <ModelISOYM
                v-model="jobValue.dateEnd"
                label="Дата окончания"
                class="model"
                :disabled="jobValue.isUntilNow"
                @change="updateJobValue"
            />

            <ModelString
                v-model="jobValue.position"
                class="model"
                label="Должность"
                @change="updateJobValue"

            />
        </div>

        <ModelCheckbox
            v-if="!isMobile"
            v-model="jobValue.isUntilNow"
            label="По настоящее время"
            @change="updateJobValue"
        />

        <div class="row">
            <ModelSelect
                :value="jobValue.organizationTypeId"
                :items="dictionaryByType('wl_organization')"
                class="model"
                label="Тип организации"
                item-value="id"
                item-text="field_value"
                @change="updateOrganizationTypeId"
            />
            <ModelString
                v-if="!isStateOrganization"
                label="Организация"
                v-model="jobValue.organisation"
                @change="updateJobValue"
            />
            <ModelString
                v-else-if="jobValue.isNotFgoOrganizationFromCatalog"
                v-model="jobValue.organizationInn"
                mask="9999999999"
                label="ИНН"
                @change="updateJobValue"
            />
            <ModelAutoComplete
                v-else
                v-model="jobValue.fgoOrganization"
                :items="fgoOrganizations"
                :vizKeyPath="[
                    ['field_value'],
                ]"
                label="Структурное подразделение"
                @debounce-end="getFgoOrganizations"
                @change="updateJobValue"
            />
            <ModelCheckbox
                v-if="isStateOrganization"
                v-model="jobValue.isNotFgoOrganizationFromCatalog"
                label="Мое структурное подразделение отсутствует в справочнике, я укажу ИНН вручную"
                @change="updateJobValue"
            />
            <div v-else />
        </div>
        <div class="row">
            <ModelAutoComplete
                v-model="jobValue.region"
                label="Регион"
                class="model"
                :vizKeyPath="[
                    ['value'],
                ]"
                :items="autoCompleteAddresses"
                @debounce-end="getAutocompleteAddress"
                @selected="getFullAddress"
                @clear="jobValue.region = null"
                @change="updateJobValue"
            />

            <ModelString
                v-model="jobValue.website"
                class="model"
                label="Сайт работодателя"
                @change="updateJobValue"
            />
            <div class="model"></div>
        </div>

        <div class="row">
            <ModelSelect
                class="model"
                label="Уровень должности"
                item-value="id"
                item-text="field_value"
                :items="dictionaryByType('position_level')"
                v-model="jobValue.foreignPositionLevelId"
                @change="updateJobValue"
            />

            <ModelSelect
                v-model="jobValue.foreignWorkersNumberId"
                :items="dictionaryByType('workers_number')"
                class="model"
                label="Кол-во сотрудников организации"
                item-value="id"
                item-text="field_value"
                @change="updateJobValue"
            />

            <div class="model"></div>
        </div>

        <div class="row">
            <ModelTextArea
                v-model="jobValue.responsibilities"
                :maxlength="2500"
                label="Обязанности"
                class="model"
                @change="updateJobValue"
                counter
            />
        </div>
    </div>
</template>

<script>
import ModelString from '@/components/UI/models/ModelString';
import ModelTextArea from '@/components/UI/models/ModelTextArea';
import ModelAutoComplete from '@/components/UI/models/ModelAutoComplete';
import ModelSelect from '@/components/UI/models/ModelSelect';
import ModelISOYM from '@/components/UI/models/ModelISOYM';
import ModelCheckbox from '@/components/UI/models/ModelCheckbox';
import { post, qs } from '@/tools/http';
import { mapGetters, mapActions } from 'vuex';
import Vue from 'vue';

const getters = [
    'isMobile',
    'dictionaryByType',
];

const actions = [
    'loadDictionaryItems',
    'dictionaryAutocomplete',
];

export default {
    name: 'WideCareerJob',
    data: ()=>({
        jobValue: null,
        autoCompleteAddresses: null,
        fgoOrganizations: [],
    }),
    props: {
        job: Object,
    },
    model: {
        prop: 'job',
        event: 'change',
    },
    computed: {
        ...mapGetters(getters),
        isStateOrganization() {
            if (this.jobValue === null) {
                return false;
            }
            const orgType = this.dictionaryByType('wl_organization')
                .find((orgType) => orgType.id === this.jobValue.organizationTypeId);
            return orgType && orgType.field_name === 'wl_organization_4';
        },
    },
    async created() {
        await Promise.all([
            this.loadDictionaryItems("position_level"),
            this.loadDictionaryItems("workers_number"),
            this.loadDictionaryItems("career"),
        ]);
        this.assignJobValue();
    },
    watch: {
        'jobValue.isUntilNow'(nv, ov) {
            this.jobValue.isUntilNow = nv;
        },
        isStateOrganization() {
            if (this.isStateOrganization) {
                Vue.set(this.jobValue, 'organisation', '');
            } else {
                Vue.set(this.jobValue, 'fgoOrganization', undefined);
            }
        },
        job: {
            handler() {
                this.assignJobValue();
            },
            immediate: true,
        },
    },
    methods: {
        ...mapActions(actions),

        async getAutocompleteAddress(inputObj) {
            if (inputObj.value === '') {
                this.autoCompleteAddresses = [];
                return;
            }
            let postParams = [
                'dadata',
                'search',
                qs({ 'query': inputObj.value, type: 'address'}),
                true,
                { 'content-type': 'application/x-www-form-urlencoded' },
            ];
            let res = await post(...postParams);
            this.autoCompleteAddresses = res ? res.suggestions : [];
        },
        async getFullAddress(item){
            if (inputObj.value === '') {
                this.jobValue.region = null;
                return;
            }
            let postParams = [
                'dadata',
                'clean',
                qs({"query": item.value, "type": "address"}),
                true,
                { 'content-type': 'application/x-www-form-urlencoded' },
            ];
            let res = await post(...postParams);
            this.jobValue.region = res.suggestions[0];
        },
        async getFgoOrganizations({value}) {
            this.fgoOrganizations = await this.dictionaryAutocomplete({
                type: 'fgo_organization',
                search: value,
            });
        },
        updateOrganizationTypeId(value) {
            Vue.set(this.jobValue, 'organizationTypeId', value);
            this.updateJobValue();
        },
        assignJobValue() {
            this.jobValue = {
                ...this.job,
                responsibilities: this.job.responsibilities || '',
            };
            this.jobValue.isNotFgoOrganizationFromCatalog = this.isStateOrganization
                ? Boolean(this.jobValue.isNotFgoOrganizationFromCatalog)
                : null;
            if (this.isStateOrganization && this.jobValue.fgoOrganization === undefined) {
                this.assignFgoOrganization();
            }
        },
        updateJobValue() {
            if (this.jobValue) {
                this.$emit('change', {
                    ...this.jobValue,
                    isStateOrganization: this.isStateOrganization,
                    isNotFgoOrganizationFromCatalog: this.isStateOrganization
                        ? Boolean(this.jobValue.isNotFgoOrganizationFromCatalog)
                        : null,
                });

            }
        },
        async assignFgoOrganization() {
            const organisation = this.jobValue.organisation || '';
            if (this.isStateOrganization && organisation.length) {
                const resp = await this.dictionaryAutocomplete({
                    type: 'fgo_organization',
                    search: organisation,
                });
                Vue.set(this.jobValue, 'fgoOrganization', resp[0] || null);
            }
        },
    },
    components: {
        ModelISOYM,
        ModelCheckbox,
        ModelString,
        ModelAutoComplete,
        ModelTextArea,
        ModelSelect,
    },
};
</script>

<style lang="scss" scoped>
    @import '../../../../styles/rem';
    @import '../../../../styles/mrem';

    .titles {
        display: flex;

        > * {
            width: 26.3rem;
            font-size: .7rem;
            font-weight: 600;
            margin: .8rem 0;
        }
    }

    .control {
        font-size: .7rem;
        margin: .4rem 0 1rem;
        user-select: none;

        label {
            display: flex;
            align-items: center;
        }

        input {
            width: .6rem;
            height: .6rem;
        }
    }

    .row {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;

        > * {
            width: rem(471);
        }
    }

    .model {
        margin-left: rem(32);

        &:first-of-type {
            margin-left: 0;
        }
    }

    @import "../../../../styles/variables";
    @media (max-width: $vm) {

      .row {
        flex-direction: column;

        > * {
            width: 100%;
        }

        .data-model {
          margin-bottom: mrem(32);
        }
      }

      .date-title-mobile {
        margin-bottom: mrem(20);
        font-size: mrem(16);
        line-height: mrem(18);
        color: #98a0a9;
        font-weight: 500;
      }

      .control {
        margin-bottom: mrem(25);
        width: 50%;
        font-size: mrem(14);
        color: #98A0A9;

        input {
          width: mrem(14);
          height: mrem(14);
        }
      }
    }
</style>
